export default __webpack_public_path__ + "static/media/blockchain-image-7steg.4d5b734f.jpg";